webpackJsonp([60634008304635],{

/***/ 193:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(336);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// const CaseCompetition = props => (
	//   <div className="CaseCompetition">
	//     <div className="title">
	//       {props.title}
	//     </div>
	//     <div className="date">
	//       {props.date}
	//     </div>
	//     <div className="description">
	//       {props.description}
	//     </div>
	//   </div>
	// );
	
	// CaseCompetition.propTypes = {
	//   title: PropTypes.string.isRequired,
	//   date: PropTypes.string.isRequired,
	//   description: PropTypes.string.isRequired,
	// };
	
	var CaseCompetition = function CaseCompetition(props) {
	  return _react2.default.createElement('div', { className: 'CaseCompetition', dangerouslySetInnerHTML: { __html: props.html } });
	};
	
	exports.default = CaseCompetition;
	module.exports = exports['default'];

/***/ }),

/***/ 194:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = CaseCompetitionsList;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CaseCompetition = __webpack_require__(193);
	
	var _CaseCompetition2 = _interopRequireDefault(_CaseCompetition);
	
	__webpack_require__(337);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function CaseCompetitionsList(_ref) {
	  var comps = _ref.comps;
	
	  var caseCompetitions = comps.map(function (competition) {
	    return _react2.default.createElement(_CaseCompetition2.default, {
	      html: competition.node.html
	    });
	  });
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'CaseCompetitionsList' },
	    caseCompetitions
	  );
	} /* eslint-disable */
	
	module.exports = exports['default'];

/***/ }),

/***/ 207:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	exports.default = CaseCompetitions;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CaseCompetitionsList = __webpack_require__(194);
	
	var _CaseCompetitionsList2 = _interopRequireDefault(_CaseCompetitionsList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function CaseCompetitions(_ref) {
	  var data = _ref.data;
	
	  var caseCompetitions = data.allMarkdownRemark.edges;
	  return _react2.default.createElement(
	    'div',
	    { className: 'city-scape__container' },
	    _react2.default.createElement(_CaseCompetitionsList2.default, { comps: caseCompetitions })
	  );
	}
	
	// eslint-disable-next-line
	
	// import CaseCompetition from '../components/CaseCompetition';
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ }),

/***/ 336:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 337:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-case-competitions-jsx-809273e2685e77fc2bff.js